import CardWaitPayment from "../Components/CardWaitPayment";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import { useCustomQuery } from "../config/query";
import { User } from "../utils/profile";

const Admin = () => {
  let { data } = useCustomQuery("profile", User);
  return (
    <>
      <Navbar data={data} />
      <CardWaitPayment />
      <div style={{ position: "relative", top: "-1750px" }}>
        <Footer />
      </div>
    </>
  );
};

export default Admin;
